import { PofePaymentStatusTypeEnum, PofeStatusTypeEnum, PofeType } from "~/types-and-enums/purchaseOrderTypes";

/**
 * Get the color for the POFE status
 * @param status - The status of the POFE
 * @returns The color for the POFE status
 */
export const getColorForPofeStatus = (status?: PofeStatusTypeEnum) => {
  switch (status) {
    case PofeStatusTypeEnum.DISPUTE:
      return "text-red-500";
    case PofeStatusTypeEnum.DELIVERED:
      return "text-green-500";
    default:
      return "text-gray-500"; // default to gray
  }
};
/**
 * Get the background color for the POFE status
 * @param status - The status of the POFE
 * @returns The background color for the POFE status
 */
export const getBgColorForPofeStatus = (status: PofeStatusTypeEnum | undefined) => {
  if (!status) return "bg-gray-100";
  switch (status) {
    case PofeStatusTypeEnum.DISPUTE:
      return "bg-red-100";
    case PofeStatusTypeEnum.DELIVERED:
      return "bg-green-100";
    default:
      return "bg-gray-100";
  }
};

export const getColorForPofePaymentStatus = (status: string) => {
  switch (status) {
    case PofePaymentStatusTypeEnum.UNPAID:
      return "text-red-500";
    case PofePaymentStatusTypeEnum.PAID:
      return "text-green-500";
    default:
      return "text-gray-500"; // default to gray
  }
};

export const getBgColorForPofePaymentStatus = (status?: string) => {
  switch (status) {
    case PofePaymentStatusTypeEnum.UNPAID:
      return "bg-red-100";
    case PofePaymentStatusTypeEnum.PAID:
      return "bg-green-100";
    default:
      return "bg-gray-100";
  }
};

/**
 * Count number of POFE's with missing (empty or null or undefined) handover_date or no products
 */
export const countMissingPofeInfo = (pofes: PofeType[]) => {
  return pofes.filter((pofe) => {
    return (
      (!pofe.handover_date || pofe.pofeps.length === 0) &&
      ![PofeStatusTypeEnum.DELIVERED, PofeStatusTypeEnum.CANCELLED].includes(pofe.status as PofeStatusTypeEnum)
    );
  }).length;
};

export const getPofeStatusTranslationKey = (status: PofeStatusTypeEnum) => {
  return `status.${status?.toLowerCase()?.replace(/[ \/]/g, "-") || "-"}`;
};

export const getPurchaseOrderStatusTranslationKey = (status?: string | null): string | null => {
  if (!status) return null;
  switch (status.trim().toLowerCase()) {
    case "contracted":
      return "purchase-orders.status.contracted";
    case "completed":
      return "purchase-orders.status.completed";
    case "canceled":
    case "cancelled":
      return "purchase-orders.status.cancelled";
    default:
      return null;
  }
};
